/*!

=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import Register from 'views/Register.js';
import Login from 'views/Login.js';
import Home from 'views/Home.js';
import Patients from 'views/Patients';
import Conversations from 'views/Conversations';
import MultiRecorder from 'views/MultiRecorder';
// import Subscriptions from "views/Subscription";
import ConversationDetails from 'views/ConversationDetails';
import AffiliateDashboard from 'views/AffiliateDashboard';
import AdminDashboard from 'views/AdminDashboard';
import SessionReplayViewer from 'views/SessionReplayViewer';
import TemplateManager from 'views/TemplateManager';
import TemplateBuilder from 'views/TemplateBuilder';
import Templates from 'views/Templates';
import ResetEmail from 'views/ResetEmail.js';
import PasswordReset from 'views/ResetPassword.js';
import VerifyEmailSent from 'views/VerifyEmailSent.js';
import VerifyEmail from 'views/VerifyEmail.js';
import VerifyPhone from 'views/VerifyPhone.js';
import MicRequest from 'views/askForMicrophone';
import UserSettings from 'views/UserSettings';
import Referrals from 'views/Referrals';
import PdfTemplateBuilder from 'views/PdfTemplateBuilder';
import Integrations from 'views/Integrations';
import ChooseTemplateBuilder from 'views/ChooseTemplateBuilder';
import NewReleases from 'views/NewReleases';
import AdminPortal from 'views/settingsViews/AdminPortal';
import AccountBilling from 'views/AccountBilling';
import Icons from 'views/examples/Icons';
import AnalyticsDashboard from 'views/AnalyticsDashboard';
import TemplateLibrary from 'views/TemplateLibrary';
import TemplateLibraryBrowseByCategory from 'views/TemplateLibraryBrowseByCategory';
import TemplateLibraryCollections from 'views/TemplateLibraryCollections';
import TemplateLibraryDetails from 'views/TemplateLibraryDetails';
import CrispChat from 'views/CrispChat';
import GoToEMR from 'views/GoToEMR';
var routes = [
  {
    path: '/home',
    name: 'Home',
    icon: 'ni ni-shop text-primary',
    component: <Home />,
    layout: '/User',
    show: true
  },
  {
    path: '/patients',
    name: 'Patients',
    icon: 'ni ni-single-02 text-yellow',
    component: <Patients />,
    layout: '/User',
    show: true
  },
  {
    path: '/conversations',
    name: 'Visits',
    icon: 'ni ni-bullet-list-67 text-red',
    component: <Conversations />,
    layout: '/User',
    show: true
  },
  {
    path: '/conversations/multi-recorder',
    name: 'Multi Recorder',
    icon: 'ni ni-note-03 text-red',
    component: <MultiRecorder />,
    layout: '/User',
    show: false
  },
  {
    path: '/integrations',
    name: 'Integrations',
    icon: 'ni ni-key-25 text-info',
    component: <Integrations />,
    layout: '/User'
  },
  {
    path: '/micRequest',
    name: 'MicrophoneRequest',
    icon: 'ni ni-shop text-blue',
    component: <MicRequest />,
    layout: '/auth'
  },

  {
    path: '/login',
    name: 'Login',
    icon: 'ni ni-key-25 text-info',
    component: <Login />,
    layout: '/auth'
  },
  {
    path: '/register',
    name: 'Register',
    icon: 'ni ni-circle-08 text-pink',
    component: <Register />,
    layout: '/auth'
  },
  {
    path: '/icons',
    name: 'Icons',
    icon: 'ni ni-planet text-blue',
    component: <Icons />,
    layout: '/User'
  },
  {
    path: '/conversations/details',
    name: 'Conversation Details',
    icon: 'ni ni-palette text-blue',
    component: <ConversationDetails />,
    layout: '/User'
  },
  {
    path: '/templates/manager',
    name: 'Template Manager',
    icon: 'ni ni-palette text-blue',
    component: <TemplateManager />,
    layout: '/User'
  },
  {
    path: '/template/library',
    name: 'Template Library',
    icon: 'ni ni-single-copy-04',
    component: <TemplateLibrary />,
    layout: '/User',
    show: false
  },
  {
    path: '/template/library/browse',
    name: 'Template Library See All',
    icon: 'ni ni-single-copy-04',
    component: <TemplateLibraryBrowseByCategory />,
    layout: '/User',
    show: false
  },
  {
    path: '/template/library/details',
    name: 'Template Details',
    icon: 'ni ni-single-copy-04',
    component: <TemplateLibraryDetails />,
    layout: '/User',
    show: false
  },
  {
    path: '/template/library/list',
    name: 'Template Info1',
    icon: 'ni ni-single-copy-04',
    component: <TemplateLibraryCollections />,
    layout: '/User',
    show: false
  },
  {
    path: '/templates/choose',
    name: 'Create Template',
    icon: 'ni ni-ruler-pencil text-blue',
    component: <ChooseTemplateBuilder />,
    layout: '/User',
    show: true
  },
  {
    path: '/templates',
    name: 'Note Settings',
    icon: 'ni ni-palette text-green',
    component: <Templates />,
    layout: '/User',
    show: true
  },
  {
    path: '/templates/builder',
    name: 'Template Builder',
    icon: 'ni ni-ruler-pencil text-blue',
    component: <TemplateBuilder />,
    layout: '/User'
  },
  {
    path: '/affiliate/dashboard',
    name: 'Affiliate Dashboard',
    icon: 'ni ni-palette text-blue',
    component: <AffiliateDashboard />,
    layout: '/User'
  },
  // {
  //   path: "/subscriptions",
  //   name: "Subscriptions",
  //   icon: "ni ni-shop text-blue",
  //   component: <Subscriptions />,
  //   layout: "/User",
  //   show: true,
  // },
  {
    path: '/admin/dashboard',
    name: 'Admin Dashboard',
    icon: 'ni ni-shop text-blue',
    component: <AdminDashboard />,
    layout: '/User'
  },
  {
    path: '/admin/replays',
    name: 'Session Replays',
    icon: 'fa fa-video text-blue',
    component: <SessionReplayViewer />,
    layout: '/User',
    show: false
  },
  {
    path: '/dashboard',
    name: 'Analytics Dashboard',
    icon: 'ni ni-chart-bar text-blue',
    component: <AnalyticsDashboard />,
    layout: '/User'
  },
  {
    path: '/reset/email',
    name: 'Reset Email',
    icon: 'ni ni-single-02 text-yellow',
    component: <ResetEmail />,
    layout: '/auth'
  },
  {
    path: '/reset/Password',
    name: 'Reset Password',
    icon: 'ni ni-single-02 text-yellow',
    component: <PasswordReset />,
    layout: '/auth'
  },
  {
    path: '/verify/sent',
    name: 'Verify Email Sent',
    icon: 'ni ni-email-83 text-yellow',
    component: <VerifyEmailSent />,
    layout: '/auth'
  },
  {
    path: '/verify/email',
    name: 'Verify Email',
    icon: 'ni ni-email-83 text-yellow',
    component: <VerifyEmail />,
    layout: '/auth'
  },
  {
    path: '/verify/phone',
    name: 'Verify Phone',
    icon: 'ni ni-mobile-button text-yellow',
    component: <VerifyPhone />,
    layout: '/auth'
  },
  {
    path: '/settings',
    name: 'User Settings',
    icon: 'fa fa-cogs',
    component: <UserSettings />,
    layout: '/User',
    show: true
  },
  {
    path: '/admin/settings',
    name: 'Admin Settings',
    icon: 'ni ni-circle-08 text-orange',
    component: <AdminPortal />,
    layout: '/User',
    show: false,
    // Split into the sidebar's Admin group (COM-471); kept for old links.
    sidebar: false
  },
  {
    path: '/admin/team',
    name: 'Team',
    icon: 'ni ni-circle-08 text-orange',
    component: <AdminPortal key="team" section="team" />,
    layout: '/User',
    adminSection: true
  },
  {
    path: '/admin/insights',
    name: 'Insights',
    icon: 'ni ni-chart-bar-32 text-purple',
    component: <AdminPortal key="insights" section="insights" />,
    layout: '/User',
    adminSection: true
  },
  {
    path: '/admin/guidelines',
    name: 'Clinic Guidelines',
    icon: 'ni ni-check-bold text-success',
    component: <AdminPortal key="guidelines" section="guidelines" />,
    layout: '/User',
    adminSection: true
  },
  {
    path: '/account/billing',
    name: 'Account & Billing',
    icon: 'ni ni-credit-card text-info',
    component: <AccountBilling />,
    layout: '/User',
    adminSection: true
  },
  {
    path: '/account/referrals',
    name: '$10 Off Every Month 🎁',
    icon: 'fa fa-gift text-green',
    component: <Referrals />,
    layout: '/User',
    // COM-608: promo removed from the tray; route kept so existing links still work.
    sidebar: false
  },
  {
    path: '/templates/builder/pdf',
    name: 'PDF Template Builder',
    icon: 'ni ni-ruler-pencil text-blue',
    component: <PdfTemplateBuilder />,
    layout: '/User'
  },
  {
    path: '/releases',
    name: "What's New",
    icon: 'ni ni-trophy text-blue',
    component: <NewReleases />,
    layout: '/User'
  },
  {
    path: '/crisp/chat',
    name: 'Crisp Chat',
    icon: 'ni ni-chat-round text-blue',
    component: <CrispChat />,
    layout: '/User'
  }
];
export default routes;
